import "@/App.css";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "@/i18n";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import About from "@/components/About";
import Chapters from "@/components/Chapters";
import Specialties from "@/components/Specialties";
import ExpatLife from "@/components/ExpatLife";
import Formats from "@/components/Formats";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function App() {
  return (
    <LangProvider>
      <ReactLenis root options={{ lerp: 0.08, duration: 1.3, smoothWheel: true }}>
        <div className="grain bg-cream font-sans text-forest antialiased selection:bg-sagedeep selection:text-forest">
          <Nav />
          <main>
            <Hero />
            <EditorialMarquee />
            <About />
            <Chapters />
            <Specialties />
            <ExpatLife />
            <Formats />
            <Contact />
          </main>
          <Footer />
          <Toaster position="bottom-center" />
        </div>
      </ReactLenis>
    </LangProvider>
  );
}
